import ServiceUpdateForm from './ServiceUpdateForm';

export default ServiceUpdateForm;